.downloadLink {
  text-decoration: none;
  color: inherit;
}
